import { useGetLocationHours } from '@uturn/api/v1';
import { SheetHeader, SheetTitle } from '@uturn/ui-kit';
import { useTranslation } from 'react-i18next';
import { LoadingSpan } from '@uturn/portal/components';

export function ShipmentLocationOpeningHours({ id }: { id: number }) {
	const { t } = useTranslation();
	const {
		data: locationHours,
		isPending,
		isSuccess,
		isError,
	} = useGetLocationHours(id, {
		query: {
			select: (data) => data.data,
		},
	});

	return (
		<>
			<SheetHeader>
				<SheetTitle>
					<h2 className="text-foreground text-2xl font-bold">
						{t(
							'pages.shipment-detail.modal.location-opening-hours.heading',
							'Openingshours',
						)}
					</h2>
				</SheetTitle>
			</SheetHeader>
			{isPending && <LoadingSpan />}
			{isError && (
				<span className="text-red-500">Error loading location hours.</span>
			)}
			{isSuccess && (
				<div className="text-foreground flex flex-col gap-0.5 py-4 text-sm font-medium leading-6">
					{Object.entries(locationHours)
						.filter(
							([key]) =>
								key !== 'id' && key !== 'locationId' && key !== 'weekdays',
						)
						.map(([key, val]) => {
							return (
								<div
									key={key}
									className="grid grid-cols-[minmax(0,_2.5fr),_minmax(0,_7fr)]"
								>
									<span className="capitalize">{key}:</span>
									<span>{String(val)}</span>
								</div>
							);
						})}
				</div>
			)}
		</>
	);
}
